import { Component } from "react";

export interface Props {
    serviceTitle: Record<string, string>;
    serviceDesc: Record<string, string>;
    serviceItems: Array<Record<string, string>>;
    idealFor: Record<string, string>;
    idealForList: Array<Record<string, string>>;
    icon: string;
    lang: string;
}

export default class ServicesRow extends Component<Props> {
    render() {
        return (
            <div className="service-card">
                <div className="service-header">
                    {this.props.icon && (
                        <i className={`service-icon ${this.props.icon}`}></i>
                    )}
                    <h3 className="service-title">{this.props.serviceTitle[this.props.lang]}</h3>
                </div>

                <p className="service-description">{this.props.serviceDesc[this.props.lang]}</p>

                {this.props.serviceItems && this.props.serviceItems.length > 0 && (
                    <ul className="service-items">
                        {this.props.serviceItems.map((item, idx) => (
                            <li key={idx}>
                                <i className="fas fa-check-circle"></i>
                                <span>{item[this.props.lang]}</span>
                            </li>
                        ))}
                    </ul>
                )}

                {this.props.idealForList && this.props.idealForList.length > 0 && (
                    <div className="service-ideal">
                        <strong>{this.props.idealFor[this.props.lang]}</strong>
                        <ul className="ideal-list">
                            {this.props.idealForList.map((item, idx) => (
                                <li key={idx}>{item[this.props.lang]}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}
